import AsyncStorage from "@react-native-async-storage/async-storage";
import {
    SERVER_ADDRESS
} from "../constants";

export const request = async <T = unknown>(endpoint: string, options: RequestInit = {}): Promise<T> => {
    const token = await AsyncStorage.getItem("authToken");

    const headers: Record<string, string> = {
        "Content-Type": "application/json",
        ...(options.headers as Record<string, string>)
    };

    if(token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${SERVER_ADDRESS}${endpoint}`, {
        ...options,
        headers
    });

    const data = await response.json() as T;

    if(!response.ok) {
        throw data;
    }

    return data;
};
